import React from "react";
import NFLookupEmptyForms from "../../../../Shared/NewForms/NFLookupEmptyForms";

function AssemblyDisassemblyOrdersGenericSkeleton() {
  return (
    <>
      <NFLookupEmptyForms />
    </>
  );
}

export default AssemblyDisassemblyOrdersGenericSkeleton;
